export default {
  cardCorpData: [],
  cardCorpEventData: [],
  cardDataForSearch: [],
  cardDataQueryAndResult: [],
  benefitDataDepth: [],
  benefitDataFlat: [],
  cardCoverData: [],
  listOfCalledAPI: [],
  displayCateData: [],
  displayData: [],
  displayPage: [],
  videoData: {},
  isUpdatedDisplayData: false,
  gorillaChartData: [],
  pageYOffset: 0,
  openCompareSlot: false,
  bigCompareSlot: false,
  bigCompareSlotPosition: 0,
  smallToastBanner: false,
  compareSlotData: [],
  compareRcmdModal: false,
  currentChartTitle: '',
  openAllChartDialog: false,
  openAwd1Dialog: false,
  openAwd2Dialog: false,
  openAwd3Dialog: false,
  openAwd4Dialog: false,
  openAwd5Dialog: false,
  openSpe1Dialog: false,
  openSpe2Dialog: false,
  openSpe3Dialog: false,
  openSpe4Dialog: false,
  openReturn1Dialog: false,
  openReturn2Dialog: false,
  openReturn3Dialog: false,
  openReturn4Dialog: false,
  openCheckDialog: false,
  openBrandDialog: false,
  openKBcorpDialog: false,
  openShareDialog: false,
  openShare2Dialog: false,
  openFaqDialog: false,
  openFooterDialog: false,
  openShorts1Dialog: false,
  openShorts2Dialog: false,
  openShorts3Dialog: false,
  openShorts4Dialog: false,
  openShorts5Dialog: false,
  currentCalendarLabel: '',
  openCalendarDialog: false,
  currentTeam: {},
  currentTeamChartData: [],
  currentTeamCardData: [],
  currentTeamEventData: [],
  currentEventData: [],
  currentContentsData: {},
  openTeamDropdown: false,
  currentCard: {},
  slotIndex: -1,
  froalaAlertText: '<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a>',
  eventLayerOpen: false,
  eventLayerDetail: '',
}
